export const TESTIDS = {
  // Navbar
  NAV_HOME: 'nav-home-link',
  NAV_ABOUT: 'nav-about-link',
  NAV_PRODUCTS: 'nav-products-link',
  NAV_CLIENTS: 'nav-clients-link',
  NAV_CONTACT: 'nav-contact-link',
  NAV_ENQUIRE_BTN: 'nav-enquire-btn',
  NAV_LOGO: 'nav-logo',
  MOBILE_MENU_TOGGLE: 'mobile-menu-toggle',
  MOBILE_MENU_CLOSE: 'mobile-menu-close',

  // Hero
  HERO_SECTION: 'hero-section',
  HERO_EXPLORE_BTN: 'hero-explore-products-btn',
  HERO_QUOTE_BTN: 'hero-get-quote-btn',
  HERO_TAGLINE: 'hero-tagline',

  // Trust Bar
  TRUST_BAR: 'trust-bar',

  // About
  ABOUT_SECTION: 'about-snapshot-section',
  ABOUT_READ_MORE: 'about-read-more-link',

  // Products
  PRODUCTS_SECTION: 'products-section',
  PRODUCT_CARD: 'product-card',
  PRODUCT_FILTER_ALL: 'product-filter-all',
  PRODUCT_FILTER_POWDER: 'product-filter-powder',
  PRODUCT_FILTER_BLENDED: 'product-filter-blended',
  PRODUCT_ENQUIRE_BTN: 'product-enquire-btn',

  // Why Choose Us
  WHY_CHOOSE_SECTION: 'why-choose-section',

  // Client Segments
  CLIENT_SECTION: 'client-segments-section',

  // Stats
  STATS_SECTION: 'stats-section',

  // Packaging
  PACKAGING_SECTION: 'packaging-section',
  REQUEST_SAMPLES_BTN: 'request-samples-btn',

  // Contact CTA
  CONTACT_CTA_CALL: 'contact-cta-call-btn',
  CONTACT_CTA_EMAIL: 'contact-cta-email-btn',

  // Footer
  FOOTER: 'footer-section',

  // Contact Form
  FORM_NAME: 'form-full-name',
  FORM_COMPANY: 'form-company-name',
  FORM_BUSINESS_TYPE: 'form-business-type',
  FORM_CITY: 'form-city',
  FORM_PHONE: 'form-phone',
  FORM_PRODUCT_INTEREST: 'form-product-interest',
  FORM_MESSAGE: 'form-message',
  FORM_SUBMIT: 'form-submit-btn',
  FORM_SUCCESS: 'form-success-message',

  // B2B Form
  B2B_FORM_NAME: 'b2b-form-name',
  B2B_FORM_COMPANY: 'b2b-form-company',
  B2B_FORM_CITY: 'b2b-form-city',
  B2B_FORM_REQUIREMENT: 'b2b-form-requirement',
  B2B_FORM_SUBMIT: 'b2b-form-submit-btn',

  // Pages
  HOME_PAGE: 'home-page',
  ABOUT_PAGE: 'about-page',
  PRODUCTS_PAGE: 'products-page',
  CLIENTS_PAGE: 'clients-page',
  CONTACT_PAGE: 'contact-page',
};
